// Wait for theme's slideshow initialization to complete
document.addEventListener('DOMContentLoaded', function() {
  // Initialize text sliders after a short delay to ensure main sliders are ready
  setTimeout(function() {
    initializeTextSliders();
  }, 100);
});

function initializeTextSliders() {
  const textSliders = document.querySelectorAll('.text-slideshow');
  
  textSliders.forEach(function(slider) {
    // Check if Flickity is available
    if (typeof Flickity === 'undefined') {
      console.error('Flickity is not loaded');
      return;
    }
    
    // Initialize Flickity on text slider
    const flkty = new Flickity(slider, {
      // Options
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      wrapAround: false,
      autoPlay: slider.dataset.autoplay === 'true' ? parseInt(slider.dataset.speed) : false,
      pauseAutoPlayOnHover: true,
      draggable: true,
      adaptiveHeight: false,
      setGallerySize: false, // Important: let CSS control the height
      imagesLoaded: false, // No images in text slider
      percentPosition: false,
      // Custom initialization
      on: {
        ready: function() {
          // Remove loading class
          slider.classList.remove('loading');
          slider.classList.remove('loading--delayed');
          
          // Sync with main slider if desired
          // syncWithMainSlider(slider, flkty);
        }
      }
    });
    
    // Store Flickity instance on element
    slider.flickity = flkty;
  });
}

function syncWithMainSlider(textSlider, textFlickity) {
  // Find corresponding main slider
  const mainSliderId = textSlider.id.replace('TextSlideshow-', 'Slideshow-');
  const mainSlider = document.getElementById(mainSliderId);
  
  if (!mainSlider) return;
  
  // Wait for main slider to be initialized
  const checkMainSlider = setInterval(function() {
    const mainFlickity = Flickity.data(mainSlider);
    
    if (mainFlickity) {
      clearInterval(checkMainSlider);
      
      // Sync text slider with main slider
      mainSlider.addEventListener('change.flickity', function() {
        const index = mainFlickity.selectedIndex;
        // Only sync if we have corresponding text slides
        if (index < textFlickity.cells.length) {
          textFlickity.select(index);
        }
      });
      
      // Optionally sync main slider with text slider
      textSlider.addEventListener('change.flickity', function() {
        const index = textFlickity.selectedIndex;
        // Only sync if we have corresponding image slides
        if (index < mainFlickity.cells.length) {
          mainFlickity.select(index);
        }
      });
    }
  }, 100);
  
  // Stop checking after 5 seconds
  setTimeout(function() {
    clearInterval(checkMainSlider);
  }, 5000);
}

// Handle window resize
let resizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    const textSliders = document.querySelectorAll('.text-slideshow');
    textSliders.forEach(function(slider) {
      if (slider.flickity) {
        slider.flickity.resize();
      }
    });
  }, 250);
});

// If theme uses theme.slideshows array, integrate with it
if (window.theme && window.theme.slideshows) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.text-slideshow')) {
      setTimeout(initializeTextSliders, 100);
    }
  });
}